import { render, staticRenderFns } from "./SocialDiscount.vue?vue&type=template&id=6497c216&scoped=true"
import script from "./SocialDiscount.vue?vue&type=script&lang=ts"
export * from "./SocialDiscount.vue?vue&type=script&lang=ts"
import style0 from "./SocialDiscount.vue?vue&type=style&index=0&id=6497c216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6497c216",
  null
  
)

export default component.exports